export const closeMenuIcon = '/icons/x.svg'
export const flowcodeNavLogo = '/static/flowcode-black-nav-logo.svg'
export const rightArrowBlue = '/icons/arrow-right-blue.svg'
export const circlePlus = '/icons/circle-plus-fill.svg'
